const news = {
    getLists: { api: '/api.php/Case/getLists', },
    getDetail: { api: '/api.php/Case/getDetail', },
}
export default news
